/**
 * TRIO PDP CRO (Sep 26)
 * - Scrolls the stars/review-count link up top down to the Judge.me widget.
 *   Falls back to #reviews -> any element with id="reviews" if present.
 * - On desktop pointers, shows a 320px floating preview of the attachment-card
 *   thumbnail after 1.4s of continuous hover.
 */
(function () {
  var REVIEW_WIDGET_SELECTORS = [
    '.jdgm-rev-widg',
    '.jdgm-widget',
    '#judgeme_product_reviews',
    '#reviews'
  ];

  function findReviewWidget() {
    for (var i = 0; i < REVIEW_WIDGET_SELECTORS.length; i++) {
      var el = document.querySelector(REVIEW_WIDGET_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest ? evt.target.closest('[data-reviews-scroll]') : null;
    if (!link) return;

    var target = findReviewWidget();
    if (!target) return;

    evt.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, false);

  /* ---- Hover preview for attachment thumbnails (desktop only) ---- */
  var HOVER_DELAY_MS = 1400;
  var PREVIEW_SIZE = 320;
  var VIEWPORT_GUTTER = 16;

  var previewEl = null;
  var hoverTimer = null;

  function supportsHoverPointer() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function ensurePreviewEl() {
    if (previewEl) return previewEl;
    previewEl = document.createElement('div');
    previewEl.className = 'pdp-cro-attachment-preview';
    previewEl.setAttribute('aria-hidden', 'true');
    previewEl.innerHTML = '<img alt="" />';
    document.body.appendChild(previewEl);
    return previewEl;
  }

  function positionPreview(sourceEl) {
    if (!previewEl) return;
    var rect = sourceEl.getBoundingClientRect();
    var left = rect.right + 12;
    var top = rect.top + rect.height / 2 - PREVIEW_SIZE / 2;

    // Flip to left side if it would overflow the viewport
    if (left + PREVIEW_SIZE + VIEWPORT_GUTTER > window.innerWidth) {
      left = rect.left - PREVIEW_SIZE - 12;
    }
    top = Math.max(VIEWPORT_GUTTER, Math.min(top, window.innerHeight - PREVIEW_SIZE - VIEWPORT_GUTTER));
    previewEl.style.left = left + 'px';
    previewEl.style.top = top + 'px';
  }

  function showPreview(sourceEl) {
    var img = sourceEl.querySelector('img');
    if (!img || !img.src) return;
    ensurePreviewEl();
    var pimg = previewEl.querySelector('img');
    pimg.src = img.src;
    pimg.alt = img.alt || '';
    positionPreview(sourceEl);
    previewEl.setAttribute('data-visible', '1');
  }

  function hidePreview() {
    if (previewEl) previewEl.removeAttribute('data-visible');
  }

  function cancelHoverTimer() {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  }

  document.addEventListener('mouseover', function (evt) {
    if (!supportsHoverPointer()) return;
    var card = evt.target.closest ? evt.target.closest('.mounting-card__image') : null;
    if (!card) return;
    // Only show preview if there's an actual <img> in the thumb (skip the X icon card)
    if (!card.querySelector('img')) return;

    cancelHoverTimer();
    hoverTimer = setTimeout(function () {
      showPreview(card);
    }, HOVER_DELAY_MS);
  });

  document.addEventListener('mouseout', function (evt) {
    var card = evt.target.closest ? evt.target.closest('.mounting-card__image') : null;
    if (!card) return;
    cancelHoverTimer();
    hidePreview();
  });

  window.addEventListener('scroll', function () {
    cancelHoverTimer();
    hidePreview();
  }, { passive: true });

  /* ---- Clear the pending-attachment flag once a mounting is picked ---- */
  function clearPendingFlag() {
    document.querySelectorAll('.product-form[data-pending-attachment="true"]').forEach(function (f) {
      f.removeAttribute('data-pending-attachment');
    });
  }

  document.addEventListener('change', function (evt) {
    if (!evt.target.classList) return;
    if (!evt.target.classList.contains('mounting-card__check')) return;
    clearPendingFlag();
  }, true);

  // Also clear on first load if the picker already has a selection applied via JS
  function pollInitialSelection() {
    var pickers = document.querySelectorAll('mounting-option-picker');
    if (!pickers.length) {
      clearPendingFlag();
      return;
    }
    var anyPicked = Array.prototype.some.call(pickers, function (p) {
      return p.querySelector('.mounting-card__check:checked');
    });
    if (anyPicked) clearPendingFlag();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(pollInitialSelection, 0);
    });
  } else {
    setTimeout(pollInitialSelection, 0);
  }

  /* ---- Required-option validation ----
   *
   * Shopify preselects the first variant via `select_first_variant`, so option
   * dropdowns look answered on load. For option names that are phrased as a
   * question (end with "?"), we also require an explicit user interaction
   * before the CTAs will proceed — the preselected default alone isn't enough.
   */
  function needsExplicitChoice(sel) {
    var name = sel.dataset.option || '';
    if (name.trim().slice(-1) === '?') return true;
    var legend = sel.querySelector('legend, label');
    if (legend && legend.textContent.trim().slice(-1) === '?') return true;
    return false;
  }

  function tagExplicitChoiceSelectors() {
    document.querySelectorAll('.product-form variant-picker .option-selector:not(.option-selector--custom)').forEach(function (sel) {
      if (!needsExplicitChoice(sel)) return;
      if (sel.hasAttribute('data-pdp-cro-needs-answer')) return;
      sel.setAttribute('data-pdp-cro-needs-answer', '1');
    });
  }

  function clearExplicitChoiceFlag(sel) {
    if (sel && sel.hasAttribute('data-pdp-cro-needs-answer')) {
      sel.removeAttribute('data-pdp-cro-needs-answer');
    }
  }

  document.addEventListener('change', function (evt) {
    var sel = evt.target.closest ? evt.target.closest('.option-selector') : null;
    if (sel) clearExplicitChoiceFlag(sel);
  }, true);

  // Custom-select dropdowns fire click (not always change) when picking an option
  document.addEventListener('click', function (evt) {
    var opt = evt.target.closest ? evt.target.closest('.custom-select__option') : null;
    if (!opt) return;
    var sel = opt.closest('.option-selector');
    if (sel) clearExplicitChoiceFlag(sel);
  }, true);

  function findMissingOptionSelector() {
    var picker = document.querySelector('.product-form variant-picker');
    if (!picker) return null;
    var selectors = picker.querySelectorAll('.option-selector:not(.option-selector--custom)');
    for (var i = 0; i < selectors.length; i++) {
      var sel = selectors[i];
      // Explicit-answer gate: user must interact even if DOM is preselected
      if (sel.hasAttribute('data-pdp-cro-needs-answer')) return sel;

      var hasValue = false;
      if (sel.dataset.selectorType === 'dropdown') {
        var opt = sel.querySelector('.custom-select__option[aria-selected="true"]');
        hasValue = !!(opt && opt.dataset.value !== '');
      } else {
        var checked = sel.querySelector('input:checked');
        hasValue = !!(checked && checked.value !== '');
      }
      if (!hasValue) return sel;
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagExplicitChoiceSelectors);
  } else {
    tagExplicitChoiceSelectors();
  }

  function flashMissing(sel) {
    var label = sel.querySelector('legend, label');
    var optName = (sel.dataset.option || (label && label.textContent) || 'this option').trim();
    var msg = optName.slice(-1) === '?'
      ? 'Please answer: ' + optName
      : 'Please choose ' + optName + ' to continue.';
    sel.setAttribute('data-missing-label', msg);
    sel.classList.remove('pdp-cro-missing');
    void sel.offsetWidth; // restart the shake animation
    sel.classList.add('pdp-cro-missing');

    var y = sel.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });

    var firstInput = sel.querySelector(
      'input:not([type="hidden"]):not([disabled]), .custom-select, button'
    );
    if (firstInput && typeof firstInput.focus === 'function') {
      setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 320);
    }
  }

  function clearMissingOn(sel) {
    sel.classList.remove('pdp-cro-missing');
    sel.removeAttribute('data-missing-label');
  }

  // Clear the highlight once the user interacts with any option
  document.addEventListener('change', function (evt) {
    var sel = evt.target.closest ? evt.target.closest('.option-selector.pdp-cro-missing') : null;
    if (sel) clearMissingOn(sel);
  }, true);
  document.addEventListener('click', function (evt) {
    var sel = evt.target.closest ? evt.target.closest('.option-selector.pdp-cro-missing') : null;
    if (sel) clearMissingOn(sel);
  }, true);

  function validateBeforeBuy(evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    var trigger = target.closest(
      '[data-purchase-now], .btn.add-to-cart, button.add-to-cart'
    );
    if (!trigger) return;

    var missing = findMissingOptionSelector();
    if (!missing) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    flashMissing(missing);
  }

  // Use capture so we run before the Purchase handler and the theme's ATC handler
  document.addEventListener('click', validateBeforeBuy, true);

  /* ---- Sticky Purchase bar: shown when the inline Purchase CTA is off-screen ---- */
  function initStickyPurchase() {
    var inlineBtn = document.querySelector('.product-form .btn.pdp-cro-purchase[data-purchase-now]');
    if (!inlineBtn || !('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'pdp-cro-sticky-cta';
    bar.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'pdp-cro-sticky-cta__inner';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--large pdp-cro-purchase';
    btn.setAttribute('data-purchase-now', '');
    btn.setAttribute('data-sticky', '1');
    btn.textContent = inlineBtn.textContent.trim() || 'Purchase';
    if (inlineBtn.disabled) btn.disabled = true;

    inner.appendChild(btn);

    // Mirror the inline Add-to-Cart button next to Purchase. Clicks forward
    // to the real button so the theme's AJAX add-to-cart flow runs unchanged.
    var inlineAtc = document.querySelector('.product-form .btn.add-to-cart');
    var atcBtn = null;
    if (inlineAtc) {
      atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'btn btn--large add-to-cart';
      atcBtn.setAttribute('data-sticky', '1');
      atcBtn.textContent = (inlineAtc.textContent || '').trim() || 'Add to cart';
      if (inlineAtc.disabled) atcBtn.disabled = true;
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        inlineAtc.click();
      });
      inner.appendChild(atcBtn);
    }

    bar.appendChild(inner);
    document.body.appendChild(bar);

    // Mirror the inline button's horizontal position + width so the sticky
    // CTA sits in the same column as it does on the page.
    function syncHorizontal() {
      var rect = inlineBtn.getBoundingClientRect();
      if (!rect.width) return;
      inner.style.width = rect.width + 'px';
      inner.style.marginLeft = rect.left + 'px';
      inner.style.marginRight = 'auto';
    }
    syncHorizontal();
    window.addEventListener('resize', syncHorizontal);
    window.addEventListener('orientationchange', syncHorizontal);
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncHorizontal).observe(inlineBtn);
    }

    // CRO Oct 26: also hide the sticky bar once the shopper has scrolled past
    // the "Complete your set up" (mounting-option-picker) section — they've
    // already seen the Purchase CTA + attachments and the bar becomes noise.
    var pastSection = false;
    var mountingPicker = document.querySelector('mounting-option-picker');

    function inlineIsOffscreen() {
      var r = inlineBtn.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom < 0 || r.top > vh;
    }

    var inlineOffscreen = inlineIsOffscreen();

    function updateBarVisibility() {
      var visible = inlineOffscreen && !pastSection;
      bar.setAttribute('data-visible', visible ? '1' : '0');
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inlineOffscreen = !entry.isIntersecting;
        updateBarVisibility();
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -40px 0px' });

    observer.observe(inlineBtn);

    if (mountingPicker) {
      var checkPast = function () {
        var r = mountingPicker.getBoundingClientRect();
        var next = r.bottom <= 0;
        if (next !== pastSection) {
          pastSection = next;
          updateBarVisibility();
        }
      };
      checkPast();
      window.addEventListener('scroll', checkPast, { passive: true });
      window.addEventListener('resize', checkPast);
    }

    // Mirror disabled state (sold out)
    var mo = new MutationObserver(function () {
      btn.disabled = inlineBtn.disabled;
    });
    mo.observe(inlineBtn, { attributes: true, attributeFilter: ['disabled'] });

    if (inlineAtc && atcBtn) {
      new MutationObserver(function () {
        atcBtn.disabled = inlineAtc.disabled;
      }).observe(inlineAtc, { attributes: true, attributeFilter: ['disabled'] });
    }

    // Mirror the product-form pending-attachment gate onto the sticky bar
    var productForm = inlineBtn.closest('.product-form');
    if (productForm) {
      var syncPending = function () {
        var pending = productForm.getAttribute('data-pending-attachment') === 'true';
        bar.setAttribute('data-pending-attachment', pending ? 'true' : 'false');
      };
      syncPending();
      new MutationObserver(syncPending).observe(productForm, {
        attributes: true,
        attributeFilter: ['data-pending-attachment']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyPurchase);
  } else {
    initStickyPurchase();
  }

  /* ---- PURCHASE secondary CTA: add current variant, then /checkout ---- */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-purchase-now]') : null;
    if (!btn) return;
    evt.preventDefault();

    var scope = btn.closest('.product-form');
    var form = btn.closest('form.js-product-form')
      || (scope && scope.querySelector('form.js-product-form'))
      || document.querySelector('.product-form form.js-product-form');
    if (!form) return;

    btn.setAttribute('data-loading', '1');

    var fd = new FormData(form);
    // Ensure quantity is present
    if (!fd.get('quantity')) fd.set('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.removeAttribute('data-loading');
        // Fallback: submit the form normally
        form.submit();
      });
  });
})();
